const surveyRecipientsReducer = (state = [], action) => {
    switch (action.type) {
      case "SET_SURVEY_RECIPIENTS":
        return action.payload;
      default:
        return state;
    }
  }
  export default surveyRecipientsReducer;